
/**
 * Utility functions for exporting data
 */

import { CustomerData } from '@/hooks/admin/types';

/**
 * Convert customer data to CSV format
 */
export const convertCustomersToCSV = (customers: CustomerData[]): string => {
  // Define the CSV header fields
  const headers = [
    'ID',
    'Email',
    'Name',
    'Plan',
    'Subscription ID',
    'Stripe Subscription ID',
    'Tracks Count',
    'Page Views',
    'Downloads',
    'Created At'
  ];

  // Create header row
  let csvContent = headers.join(',') + '\n';

  // Add data rows
  customers.forEach(customer => {
    const row = [
      customer.id,
      `"${customer.email.replace(/"/g, '""')}"`, // Escape quotes in email
      `"${customer.name.replace(/"/g, '""')}"`, // Escape quotes in name
      customer.plan || '',
      customer.subscriptionId || '',
      customer.stripeSubscriptionId || '',
      customer.tracksCount,
      customer.pageViews,
      customer.downloads,
      customer.created_at
    ];
    csvContent += row.join(',') + '\n';
  });

  return csvContent;
};

/**
 * Download data as a CSV file
 */
export const downloadCSV = (csvContent: string, filename: string): void => {
  // Create a Blob with the CSV content
  const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });
  
  // Create a download link
  const link = document.createElement('a');
  const url = URL.createObjectURL(blob);
  
  // Set up link properties
  link.setAttribute('href', url);
  link.setAttribute('download', filename);
  link.style.visibility = 'hidden';
  
  // Add to DOM, trigger download and clean up
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
};
